export const capitalize = (text: string | null) => {
  if (text) return text[0].toUpperCase() + text.slice(1);
  else return '';
};

export default capitalize;
